export default function Auth(props) {
    function onChange(e) {
        props.onDataChanged(e.target.id, e.target.value);
    }

    return (
        <div className="InputDetailsContainer">
            <section>
                <div>
                    <label htmlFor="name">Name:</label>
                    <input id="name" type="text" defaultValue={props.name} onChange={onChange}/>
                </div>
                <div>
                    <label htmlFor="brand">Brand:</label>
                    <input id="brand" type="text" defaultValue={props.brand} onChange={onChange}/>
                </div>
                <div>
                    <label htmlFor="secret">Secret:</label>
                    <input id="secret" type="password" defaultValue={props.secret} onChange={onChange}/>
                </div>
            </section>
            <button className="SpinButton" onClick={props.onClick}>Authenticate</button>
        </div>
    );
}
